import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { server } from "../server";
import axios from "axios";

const SellerActivationPage = () => {
  const { activation_token } = useParams();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (activation_token) {
      const activateShop = async () => {
        try {
          setLoading(true);
          await new Promise((resolve) => setTimeout(resolve, 2000));

          await axios.post(`${server}/shop/activation`, { activation_token });

          setSuccess(true);
          setLoading(false);

          setTimeout(() => {
            navigate("/shop-login");
          }, 3000);
        } catch (err) {
          setError(true);
          setLoading(false);
          setErrorMessage(
            err.response?.data?.message || "Shop activation failed"
          );
        }
      };
      activateShop();
    }
  }, [activation_token, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {loading && (
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-6 relative">
              <div className="absolute inset-0 border-4 border-[#086872] border-t-transparent rounded-full animate-spin"></div>
              <div className="absolute inset-3 bg-[#086872] rounded-full flex items-center justify-center">
                <span className="text-white text-2xl">🏪</span>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Activating Your Shop
            </h1>
            <p className="text-gray-500">Please wait a moment...</p>
          </div>
        )}

        {success && !loading && (
          <div className="text-center bg-white rounded-2xl shadow-xl p-8">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl">🎉</span>
            </div>
            <h1 className="text-2xl font-bold text-green-700 mb-2">
              Shop Activated!
            </h1>
            <p className="text-gray-600 mb-4">
              Your shop has been activated. Your account is now pending admin
              approval. Redirecting you to login...
            </p>
            <div className="w-full bg-gray-200 rounded-full h-1.5">
              <div className="bg-[#086872] h-1.5 rounded-full animate-pulse w-3/4"></div>
            </div>
          </div>
        )}

        {error && !loading && (
          <div className="text-center bg-white rounded-2xl shadow-xl p-8">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl">❌</span>
            </div>
            <h1 className="text-2xl font-bold text-red-700 mb-2">
              Activation Failed
            </h1>
            <p className="text-gray-600 mb-6">
              {errorMessage}
            </p>
            <button
              onClick={() => navigate("/shop-create")}
              className="px-6 py-3 bg-[#086872] text-white rounded-lg font-medium hover:bg-teal-700 transition-colors"
            >
              Register Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerActivationPage;
